import {
  TableHead,
  TableCell,
  TableRow,
  Button,
  TableContainer,
  Table,
  Paper,
  TableBody,
  Box,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getReasons, loadReasonsRequest } from '../../../redux/reasonRedux';
import { useEffect, useState } from 'react';
import { checkLoggedUser, getUser } from '../../../redux/usersRedux';
import { useTranslation } from 'react-i18next';
const ReasonListForm = ({ action, link }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const reasons = useSelector((state) => getReasons(state));
  const user = useSelector((state) => getUser(state));
  useEffect(() => {
    const start = async () => {
      await dispatch(loadReasonsRequest());
      await dispatch(checkLoggedUser());
      setLoading(false);
    };
    start();
  }, [dispatch]);
  const handleSubmit = (id) => {
    action(id);
  };

  if (!loading) {
    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="reason table">
          <TableHead>
            <TableRow>
              <TableCell>
                {t('pz05.incompatibilities.origins.description')}
              </TableCell>
              <TableCell>{t('pz05.incompatibilities.reasons.area')}</TableCell>
              <TableCell>{t('pz05.incompatibilities.reasons.type')}</TableCell>
              <TableCell>{t('pz05.incompatibilities.reasons.des')}</TableCell>
              <TableCell>
                {t('pz05.incompatibilities.reasons.addDes')}
              </TableCell>
              <TableCell>
                {t('pz05.incompatibilities.reasons.decisionMaker')}
              </TableCell>
              {(user.users.role === 'ADMIN' ||
                user.users.role === 'KIER_DS_REKLAMACJI') && (
                <TableCell align="center">{t('account.action')}</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {reasons &&
              reasons.map((el) => (
                <TableRow
                  key={el.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th">{el.source.description}</TableCell>
                  <TableCell>{el.area.description}</TableCell>
                  <TableCell>{el.inconformity.description}</TableCell>
                  <TableCell>{el.desNonCompliance.description}</TableCell>
                  <TableCell>{el.additionalDes.description}</TableCell>
                  <TableCell>{el.decisionMaker}</TableCell>
                  {(user.users.role === 'ADMIN' ||
                    user.users.role === 'KIER_DS_REKLAMACJI') && (
                    <TableCell align="center">
                      <Box sx={{ display: 'flex' }}>
                        <Button
                          sx={{ color: 'orange' }}
                          component={Link}
                          to={`/${link}/${el.id}`}
                        >
                          <EditIcon />
                        </Button>
                        <Button
                          sx={{ color: 'red' }}
                          onClick={() => handleSubmit(el.id)}
                        >
                          <DeleteIcon />
                        </Button>
                      </Box>
                    </TableCell>
                  )}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
};

export default ReasonListForm;
